
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './servicepage.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pservicepage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id62ceef00323c4d00120bd76d" >

      <div id="iv2k1h" className="">
      
      <div id="i84cpo" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <input
        name=""
        type="checkbox"
        placeholder=""
        className=""
        id="menu__toggle"
      />
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target="_blank"
        className="menu__item "
        id=""
        href="/#init"
        type=""
      >
        <>Home</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target="_blank"
        className="menu__item "
        id=""
        href="/#about"
        type=""
      >
        <>About</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target="_blank"
        className="menu__item "
        id=""
        href="/#team"
        type=""
      >
        <>Team</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target="_blank"
        className="menu__item "
        id=""
        href="/#contact"
        type=""
      >
        <>Contact</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="#"
        type=""
      >
        <>Twitter</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6z5l7" className="">
      
      <div className="" id="iqb6v5">
        
      <span className="" id="ifwhkg">
        <>Acosta's</>
      </span>
      
      </div>
      
      <img
        className=""
        id="ik785t"
        src="https://assetsprojects.s3.amazonaws.com/406450il5i9ewct.png"
        alt="undefined"
      />
      
      <div className="" id="iqj981">
        
      <span className="" id="inaxa7">
        <>Lawfirm & Associates</>
      </span>
      
      </div>
      
      </div>
      
      <div id="i65c83" className="">
      
      <div className="" id="ilmqln">
        
      <a
        target=""
        className="link "
        id=""
        href="/service"
        type=""
      >
        <>Español</>
      </a>
      
      </div>
      
      <div className="" id="ixyf5b">
        
      </div>
      
      <div className="" id="ih7vif">
        
      <a
        target="_blank"
        className="link "
        id=""
        href="/services_en"
        type=""
      >
        <>Ingles</>
      </a>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i8fj" className="">
      
      <div id="itt4x" className="">
      
      <div id="i8dn6" className="">
      
      <div className="" id="i88ni3">
        <>Nuestros</>
      </div>
      
      </div>
      
      <div id="i7eni" className="">
      
      <div className="" id="im1qvd">
        <>Servicios</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iulh4" className="">
      
      <div id="ilcz9l" className="">
      
      </div>
      
      <div id="iskol" className="">
      
      <div id="i5irz" className="">
      
      <div id="ivggr" className="">
      
      <div className="" id="ivsc7">
        <>Asuntos Notariales</>
      </div>
      
      <div id="i47ze" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ixflv" className="">
      
      <div className="" id="iafs7">
        <>Civiles</>
      </div>
      
      <div id="ib9mt" className="">
      
      </div>
      
      <div id="iu9ft" className="">
      
      <div className="" id="if3uf">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ipmi3">
        <>Escrituras de compraventa.<br /></>
      <br className="" id="" />
      <>Promesas de Venta.<br /></>
      <br className="" id="" />
      <>Hipoteca y cancelación de hipoteca.<br /></>
      <br className="" id="" />
      <>Donaciones.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i2tig6" className="">
      
      <div className="" id="i0vjo">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i32zid">
        <>Mercantiles</>
      </span>
      
      </div>
      
      <div id="iyw7tj" className="">
      
      </div>
      
      <div id="ioz3nl" className="">
      
      <div className="" id="ia5u8r">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io82u4">
        <>Constitución, Transformación o Disolución de Sociedades (Corporaciones) (Aumento y Reducción de Capital).<br /></>
      <br className="" id="" />
      <>Actas notariales en general.<br /></>
      <br className="" id="" />
      <>Testamentos.<br /></>
      <br className="" id="" />
      <>Herencias y Legados.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iy8bhi" className="">
      
      <div className="" id="iyqvpl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijdt4k">
        <>Actos de Jurisdicción Voluntaria en Sede Notarial.</>
      </span>
      
      </div>
      
      <div id="isflqg" className="">
      
      </div>
      
      <div id="ip3ng3" className="">
      
      <div className="" id="is1op3">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iv7url">
        <>Rectificaciones de Inscripción en el Registro Civil.<br /></>
      <br className="" id="" />
      <>Informaciones Ad-Perpetuam.<br /></>
      <br className="" id="" />
      <>Matrimonios (Autorización de Matrimonios dentro y fuera de Honduras, Capitulaciones Matrimoniales).<br /></>
      <br className="" id="" />
      <>Divorcio por Mutuo Consentimiento.<br /></>
      <br className="" id="" />
      <>Unión y Separación de Hecho.<br /></>
      <br className="" id="" />
      <>Autorizaciones en General.<br /></>
      <br className="" id="" />
      <>Conciliación y Arbitraje.<br /></>
      <br className="" id="" />
      <>Partición de Bienes.<br /></>
      <br className="" id="" />
      <>Remedidas de Inmuebles</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i37k8k" className="">
      
      <div className="" id="ip7h93">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io761z">
        <>Poderes: Otorgamiento, Ampliación, sustitución y Revocación</>
      </span>
      
      </div>
      
      <div id="i5xsb3" className="">
      
      </div>
      
      <div id="in8bzj" className="">
      
      <div className="" id="ijxrik">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ixuibb">
        <>Poder Especial.<br /></>
      <br className="" id="" />
      <>Poder General.<br /></>
      <br className="" id="" />
      <>Poder (Administración y Disposición).</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isa4mk" className="">
      
      <div className="" id="iohh9g">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i48ify">
        <>Propiedad en Condominio </>
      </span>
      
      </div>
      
      <div id="ijmwrn" className="">
      
      </div>
      
      <div id="irtdos" className="">
      
      <div className="" id="iqer13">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6da01">
        <>Por constitución, afectación de la propiedad.<br /></>
      <br className="" id="" />
      <>Agrupaciones de inmuebles.<br /></>
      <br className="" id="" />
      <>Servidumbre (constitución).</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="il2jp" className="">
      
      </div>
      
      </div>
      
      <div id="i9d40k" className="">
      
      <div id="i1jsxj" className="">
      
      </div>
      
      <div id="ilparc" className="">
      
      <div id="i8ws06" className="">
      
      <div id="iz9qir" className="">
      
      <div className="" id="i545qf">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="io13ji">
        <>Asuntos Administrativos en General<br /></>
      </span>
      
      </div>
      
      <div id="ic11df" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iwkent" className="">
      
      <div className="" id="iaqq06">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iod7bn">
        <>Migratorios</>
      </span>
      
      </div>
      
      <div id="i1groc" className="">
      
      </div>
      
      <div id="i71avp" className="">
      
      <div className="" id="ifccq8">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ix0e52">
        <>Residencias.<br /></>
      <br className="" id="" />
      <>Permisos de Trabajo.<br /></>
      <br className="" id="" />
      <>Permisos Especiales de Permanencia en Honduras.<br /></>
      <br className="" id="" />
      <>Legalización de Empresas y Organizaciones Extranjeras.<br /></>
      <br className="" id="" />
      <>Personerías Jurídicas.<br /></>
      <br className="" id="" />
      <>Fundaciones.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iemnxq" className="">
      
      <div className="" id="idf33t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ick86t">
        <>Asuntos Tributarios, Administrativos y Contables.</>
      </span>
      
      </div>
      
      <div id="i5r2wf" className="">
      
      </div>
      
      <div id="iph7ew" className="">
      
      <div className="" id="iqzcrj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ixbale">
        <>Impugnaciones y Demandas.<br /></>
      <br className="" id="" />
      <>Estado Financiero.<br /></>
      <br className="" id="" />
      <>Representación ante el SAR.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iaqqq9" className="">
      
      <div id="i7alth" className="">
      
      </div>
      
      <div id="ihssh9" className="">
      
      <div id="i93i73" className="">
      
      <div id="i0ofpg" className="">
      
      <div className="" id="i2808z">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="idp5jx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      <>Asuntos Judiciales<br /></>
      </span>
      
      </div>
      
      <div id="io5l7g" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i7x1zj" className="">
      
      <div className="" id="igof0t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iygu4k">
        <>Divorcio en Sede Judicial.<br /></>
      <br className="" id="" />
      <>Demandas Civiles, Mercantiles, Laborales, Administrativas.<br /></>
      <br className="" id="" />
      <>Denuncias, Acusaciones y defensas en Materia Penal.<br /></>
      <br className="" id="" />
      <>Representación en Materia Administrativa y Judicial en General.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ipjf3a" className="">
      
      </div>
      
      </div>
      
      <div id="i7xfof" className="">
      
      <div id="i9b58g" className="">
      
      </div>
      
      <div id="isofoo" className="">
      
      <div id="i8wcay" className="">
      
      <div id="iqnwly" className="">
      
      <div className="" id="i7ne5g">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="izejfs">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      <>Asuntos de Familia<br /></>
      </span>
      
      </div>
      
      <div id="izmnq1" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6zsql" className="">
      
      <div className="" id="i66e7f">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5o0ai">
        <>Reconocimientos de Hijos.<br /></>
      <br className="" id="" />
      <>Matrimonio Civil.</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ijk5" className="">
      
      <iframe
        title="Mapa"
        className=""
        id="i0wk"
        frameBorder="0"
        src="https://maps.google.com/maps?&q=Bojangles, McNab Plaza, main street, French Harbour&z=17&t=q&output=embed"
      />
      
      </div>
      
      <div id="ixax" className="">
      
      <div id="if6id8" className="">
      
      <div id="ixamfy" className="">
      
      <img
        className=""
        id="iqx8xl"
        src="https://assetsprojects.s3.amazonaws.com/406450il5i9ewct.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i9tjsk" className="">
      
      <div id="il22am" className="">
      
      </div>
      
      <div className="" id="igni1j">
        <>Acosta's</>
    <div id="" className="">
    <>Lawfirm </>
    </div>
    
    <div id="" className="">
    <>& Associates</>
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      <div id="iacgmf" className="">
      
      <div className="" id="iu9123">
        
      <span className="" id="iaypss">
        <>Roatán,  Islas de la Bahía </>
      </span>
      
      <br className="" id="i8osim" />
      
      <span className="" id="i36x8h">
        <> Honduras</>
      </span>
      
      <br className="" id="i40iea" />
      
      <span className="" id="ie87k8">
        <>Bojangles, McNab Plaza, main street, French Harbour</>
      </span>
      
      <br className="" id="iha4e8" />
      
      <span className="" id="iaq2t7">
        <>Copyright © Acosta Law Firm 2022. Todos Los Derechos Reservados</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pservicepage);
  